<div class="divider-container">
  <span class="divider-line"></span>
  <span class="divider-text">{{ text }}</span>
  <span class="divider-line"></span>
</div>
